import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * LoadBoardDefsModal
 */
export class LoadBoardDefsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      defs: null,
      errorText: null,
    }
  }

  validateAndLoad = () => {
    if (this.state.defs) {
      this.props.loadAction(this.state.defs)
    }
  }

  validateDefsList(defsList) {
    const toString = Object.prototype.toString
    const listType = toString.apply(defsList)
    const arrayType = toString.apply([])
    const stringType = toString.apply('')

    if (listType !== arrayType) {
      return { isValid: false, error: `Expecting root object to be an array, instead found type: ${listType}` }
    }

    const invalidIds = defsList.filter(def => toString.apply(def.id) !== stringType)
    if (invalidIds.length > 0) {
      return { isValid: false, error: `All Board Definitions must have a property named 'id' of type 'string'` }
    }

    const invalidNames = defsList.filter(def => toString.apply(def.name) !== stringType)
    if (invalidNames.length > 0) {
      return { isValid: false, error: `All Board Definitions must have a property named 'name' of type 'string'` }
    }

    const duplicateIds = defsList.reduce((result, def) => {
      if (!!result[def.id]) {
        result.duplicates.push(def.id)
      } else {
        result[def.id] = true
      }
      return result
    }, {duplicates: []})
    if (duplicateIds.duplicates.length > 0) {
      return { isValid: false, error: `Board Definition ids must be unique, found duplicate ids: ${duplicateIds.duplicates.join(', ')}` }
    }

    return { isValid: true }
  }

  textChanged = (event) => {
    try {
      const defs = JSON.parse(event.target.value)
      const result = this.validateDefsList(defs)

      if (!result.isValid) {
        this.setState({ errorText: result.error, defs: null })
      } else {
        this.setState({ errorText: null, defs: defs })
      }

    } catch (e) {
      this.setState({ errorText: e.toString(), defs: null })
    }
  }

  render() {
    return (
        <Dialog
          open={this.props.open}
          onClose={this.props.cancelAction}
          maxWidth='md'
        >
          <DialogTitle>Load Boards from JSON</DialogTitle>
          <DialogContent style={{ minWidth: '800px' }}>
            <TextField
              label='Board Definitions JSON'
              multiline
              fullWidth
              rows='20'
              error={!!this.state.errorText}
              helperText={this.state.errorText || ' '}
              onChange={this.textChanged}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.cancelAction}>Cancel</Button>
            <Button color='primary'
              disabled={this.state.defs === null}
              onClick={this.validateAndLoad}>Load</Button>
          </DialogActions>
        </Dialog>
    )
  }
}

LoadBoardDefsModal.propTypes = {
  open: PropTypes.bool,
  loadAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
}

export default LoadBoardDefsModal



// WEBPACK FOOTER //
// ./src/routes/BoardDefsEditor/components/LoadBoardDefsModal.js